import { ChevronUpIcon } from "lucide-react";

import { Column, Row, Text } from "@/components";
import { AgenticCallCitationIcon } from "@jobs/candidate-sheet-v2/tabs/CitationSourceIcons";
import { Button } from "@/components/ui/button";

import { CallStructuredSummaryCitation } from "@/types";

// The evidence panel behind one field. Each citation shows its setup turns
// before the quote, because a bare "Yes" is unreadable without the question it
// answered. Timestamps seek the call's player.
export const StevieCitationList = ({
  citations,
  onClose,
  onSeek,
}: {
  citations: CallStructuredSummaryCitation[];
  onClose: () => void;
  onSeek: (timestamp: string) => void;
}) => {
  /* Render */
  const renderCitation = (
    citation: CallStructuredSummaryCitation,
    index: number,
  ) => {
    return (
      <Column
        className="gap-1 border-l-2 border-slate-200 pl-3"
        key={`${citation.timestamp ?? "no-time"}-${String(index)}`}
      >
        <Row className="items-center gap-2">
          <AgenticCallCitationIcon className="h-3.5 w-3.5 shrink-0 text-slate-400" />
          <Text className="text-xs font-normal text-slate-500">
            Stevie call
          </Text>
          {citation.timestamp ? (
            <Button
              className="h-auto p-0 font-plex-mono text-[10px] font-medium uppercase tracking-wider text-primary-900"
              onClick={() => {
                onSeek(citation.timestamp ?? "");
              }}
              type="button"
              variant="link"
            >
              {citation.timestamp}
            </Button>
          ) : null}
        </Row>
        {citation.quoteContext.map((turn, turnIndex) => (
          <Text
            className="text-xs font-normal leading-5 text-slate-400"
            key={`${turn.speaker}-${String(turnIndex)}`}
          >
            {turn.speaker === "agent" ? "Stevie" : "Candidate"}: {turn.text}
          </Text>
        ))}
        <Text className="text-sm font-normal italic leading-5 text-slate-700">
          &ldquo;{citation.quote}&rdquo;
        </Text>
      </Column>
    );
  };

  const render = () => {
    return (
      <Column className="relative mt-2 gap-3 rounded-md border border-slate-200/70 bg-slate-50 px-3 py-3 pr-10">
        <Row className="items-center gap-2">
          <Text className="font-plex-mono text-[10px] font-medium uppercase tracking-wider text-slate-500">
            Source
          </Text>
          <Text className="rounded-full bg-slate-200/70 px-1.5 text-[10px] font-medium text-slate-600">
            {citations.length}
          </Text>
        </Row>
        {citations.map(renderCitation)}
        <Button
          className="absolute right-1 top-1 h-7 w-7 p-0 text-slate-400 hover:bg-slate-200/70 hover:text-slate-600"
          onClick={onClose}
          size="icon"
          title="Minimize source"
          type="button"
          variant="ghost"
        >
          <ChevronUpIcon className="h-4 w-4" strokeWidth={1.5} />
        </Button>
      </Column>
    );
  };

  return render();
};
